import { render, staticRenderFns } from "./GroupDraggable.vue?vue&type=template&id=6be5567c&scoped=true&"
import script from "./GroupDraggable.vue?vue&type=script&lang=js&"
export * from "./GroupDraggable.vue?vue&type=script&lang=js&"
import style0 from "./GroupDraggable.vue?vue&type=style&index=0&id=6be5567c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be5567c",
  null
  
)

export default component.exports